import Typography from '@mui/material/Typography'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

export const RecordDeleteDialog = ({ open, handleClose, id }) => {
    const params = useParams()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { deleteRecord, fetchRecordRefrech, isLoadingDeleteRecord } =
        useAssistantAdministrationStore((state) => state)

    const handleClickDelete = async () => {
        await deleteRecord({ recordId: id })
        if (params.recordId) {
            navigate('/records?is_archived=false')
        } else {
            await fetchRecordRefrech({
                desc: searchParams.get('desc'),
                order_by: searchParams.get('order_by'),
                is_archived: searchParams.get('is_archived') === 'true',
                workplace_id: searchParams.get('workplaceId'),
                limit: searchParams.get('limit'),
                offset: searchParams.get('offset'),
            })
            handleClose()
        }
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickDelete}
            handleClose={handleClose}
            title="Удалить запись?"
            submitButtonText="Удалить"
            isDisabled={isLoadingDeleteRecord}>
            <Typography variant="body1">
                Запись и все связанные материалы, включая стенографию и расшифровки, будут удалены
                без возможности восстановления
            </Typography>
        </ConfirmDialogWrapper>
    )
}
